import React from 'react'
import CaseStudiesCards from '../../common/Campaigncards/caseStudiesCardscopy'

const CaseStudies = () => {
  return (
    <>
     <div className="aboutus_container">
        <div className="hcontainer">
          <div className="we_have_solution_container">
            <h1 className="have_solution_heading">Case Studies</h1>

            <div className="we_case_inner">
              {/* <CaseStudiesCards /> */}
              <CaseStudiesCards />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default CaseStudies
